import { useContext } from "react";
import { MasajidContext } from "../contexts/MasajidContext";

function Header() {
  const { language } = useContext(MasajidContext);

  return (
    <div className="container-fluid full-width-container d-flex justify-content-center align-items-center">
      <img id="header-logo" src="/assets/img/logo.png" alt="MIS Logo" />
      <h1
        style={{ textAlign: "center", color: "#ffffff", marginTop: 10 }}
        lang={language === "urdu" && "ur"}
      >
        {language === "urdu" && "مساجد "}
        <span
          style={{
            color: "rgb(27, 179, 200)",
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          <strong>MIS</strong>
        </span>{" "}
        {language === "english" && "Masajid"}
      </h1>
    </div>
  );
}

export default Header;
